<template>
  <v-dialog
    content-class="view-table-dialog"
    v-model="toggleDisplay"
    width="800"
    persistent
  >
    <v-card class="px-5">
      <v-card-title class="headline px-0" primary-title>View As</v-card-title>
      <v-card-text>
        <v-row>
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            placeholder="Search"
            :hide-details="true"
            solo
            clearable
            v-model="keyword"
            autocomplete="off"
            color="dark"
          ></v-text-field>
        </v-row>
        <v-row>
          <v-col cols="12">
            <ag-grid-vue
              class="ag-theme-alpine"
              style="height: 60vh"
              :columnDefs="columnDefs"
              :defaultColDef="defaultColDef"
              :rowData="
                wholesalers.filter((x) =>
                  x.name.toLowerCase().includes(keyword.toLowerCase())
                ) || x.email.toLowerCase().includes(keyword.toLowerCase())
              "
              :gridOptions="gridOptions"
              rowSelection="single"
              @row-selected="enableViewAs"
              @grid-ready="onGridReady"
            ></ag-grid-vue>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="py-4 px-0 pb-5">
        <v-spacer></v-spacer>
        <v-btn class="primary" text @click="closeViewTable">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";

export default {
  name: "ViewTable",
  components: { AgGridVue },

  data: () => ({
    tab: null,
    toggleDisplay: false,
    keyword: "",
    columnDefs: [
      { headerName: "Company", field: "company" },
      { headerName: "Name", field: "name" },
      { headerName: "Email", field: "oneLoginEmail" },
    ],
    defaultColDef: {
      sortable: true,
      filter: true,
      resizeable: true,
    },
    gridOptions: {},
    gridApi: null,
  }),
  methods: {
    onGridReady(args) {
      let vm = this;
      vm.gridApi = args.api;
    },
    closeViewTable() {
      document.querySelector(".view-table-dialog").scrollTo(0, 0);
      this.toggleDisplay = false;
    },

    enableViewAs(val) {
      let vm = this;

      vm.setImpersonatingAs(val.data).then(() => {
        window.location.href="/";
      });
    },
  },
};
</script>
